export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/ob-step-1.png?9b8ba7c08a2ea4a3dc77049a637c6d4a";